import { render, staticRenderFns } from "./OfflineDatabaseComponent.vue?vue&type=template&id=fd030e76&scoped=true"
import script from "./OfflineDatabaseComponent.vue?vue&type=script&lang=js"
export * from "./OfflineDatabaseComponent.vue?vue&type=script&lang=js"
import style0 from "./OfflineDatabaseComponent.vue?vue&type=style&index=0&id=fd030e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd030e76",
  null
  
)

export default component.exports